// src/reducers/blogReducer.js
import {
    BLOG_CREATE_REQUEST,
    BLOG_CREATE_SUCCESS,
    BLOG_CREATE_FAIL,
    BLOG_CREATE_RESET,
    BLOG_LIST_REQUEST,
    BLOG_LIST_SUCCESS,
    BLOG_LIST_FAIL,
    BLOG_DETAILS_REQUEST,
    BLOG_DETAILS_SUCCESS,
    BLOG_DETAILS_FAIL,
    BLOG_UPDATE_REQUEST,
    BLOG_UPDATE_SUCCESS,
    BLOG_UPDATE_FAIL,
    BLOG_UPDATE_RESET,
    BLOG_DELETE_REQUEST,
    BLOG_DELETE_SUCCESS,
    BLOG_DELETE_FAIL
  } from '../actions/types';
  
  const initialState = {
    blogs: [],
    blog: null,
    loading: false,
    error: null,
    success: false
  };
  
  export const blogReducer = (state = initialState, action) => {
    switch (action.type) {
      case BLOG_CREATE_REQUEST:
      case BLOG_LIST_REQUEST:
      case BLOG_DETAILS_REQUEST:
      case BLOG_UPDATE_REQUEST:
      case BLOG_DELETE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
          success: false
        };
  
        case BLOG_LIST_SUCCESS:
          return {
            ...state,
            loading: false,
            blogs: action.payload.data,
            error: null,
            success: false   // <-- set to false here to prevent loops
          };
        
  
          case BLOG_CREATE_SUCCESS:
            return {
              ...state,
              loading: false,
              success: true, // set true only when create succeeds
            };
  
      case BLOG_DETAILS_SUCCESS:
        return {
          ...state,
          loading: false,
          blog: action.payload,
          error: null
        };
  
      case BLOG_UPDATE_SUCCESS:
        return {
          ...state,
          loading: false,
          success: true,
          error: null,
          blogs: state.blogs.map(blog =>
            blog.id === action.payload.id ? action.payload : blog
          )
        };
  
      case BLOG_DELETE_SUCCESS:
        return {
          ...state,
          loading: false,
          error: null,
          blogs: state.blogs.filter(blog => blog.id !== action.payload.id)
        };
  
      case BLOG_CREATE_FAIL:
      case BLOG_LIST_FAIL:
      case BLOG_DETAILS_FAIL:
      case BLOG_UPDATE_FAIL:
      case BLOG_DELETE_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
          success: false
        };
  
      case BLOG_CREATE_RESET:
      case BLOG_UPDATE_RESET:
        return {
          ...state,
          success: false,
          error: null
        };
  
      default:
        return state;
    }
  };